import {match} from 'ts-pattern';

import {
  useLazyGetCashReceiptV4Query,
  useRenderExpenseCashReceiptDocumentMutation,
  useRenderIncomeCashReceiptDocumentMutation,
} from '@dms/api/finance';

import {openFile} from 'shared/web';

import {handleApiError} from '../utils/handleApiError';

export function useOpenCashReceipt() {
  const [renderIncomeCashReceipt, {isLoading: isRenderingIncomeCashReceipt}] =
    useRenderIncomeCashReceiptDocumentMutation();

  const [renderExpenseCashReceipt, {isLoading: isRenderingExpenseCashReceipt}] =
    useRenderExpenseCashReceiptDocumentMutation();

  const [getCashReceipt, {isLoading: isLoadingCashReceipt}] = useLazyGetCashReceiptV4Query();

  const getRenderAction = async (cashRegisterDocumentId: string) => {
    const cashReceiptType = await getCashReceipt({cashRegisterDocumentId})
      .unwrap()
      .then((data) => data.type);

    return match(cashReceiptType)
      .with('income', () => renderIncomeCashReceipt)
      .with('expense', () => renderExpenseCashReceipt)
      .exhaustive();
  };

  const renderCashReceipt = async (cashRegisterDocumentId: string) => {
    const renderAction = await getRenderAction(cashRegisterDocumentId);

    return renderAction({renderDocumentRequestBody: {cashRegisterDocumentId}}).unwrap();
  };

  // The rejection slot rather than a trailing .catch(), so the type lookup is covered too.
  const openCashReceipt = (cashRegisterDocumentId: string) =>
    renderCashReceipt(cashRegisterDocumentId).then(
      (cashReceiptDocument) => openFile(cashReceiptDocument.pdfUrl),
      handleApiError
    );

  return {
    openCashReceipt,
    renderCashReceipt,
    isRenderingIncomeCashReceipt,
    isRenderingExpenseCashReceipt,
    isRenderingCashReceipt: isRenderingIncomeCashReceipt || isRenderingExpenseCashReceipt,
    isLoadingCashReceipt,
  };
}
